<template>
  <div class="Subpage">
    <Bigmenu :NavStatus="Bignav" :Way="3" :ShowBackBtn="true" v-on:cellback="OpenStatus" style="z-index: 2"></Bigmenu>
    <div class="frame" style="z-index: -2"></div>
    <Container v-if="!Bignav" :Type="false" :ImgUrl="'b01.png'" :Container="Container"  style="z-index: -6"></Container>
  </div>
</template>

<script>
import Bigmenu from '@/components/Bigmenu.vue'
import Back from '@/components/Back.vue';
import Container from '@/components/Container.vue';
export default {
  name: 'About',
  data () {
    return {

      Bignav: false,
      Container:{
        subtitle:"What is proton therapy?",
        videosrc:'P01.mp4',
        title:'何謂質子治療',
        list:[
          {
            body:"質子放射治療為無創癌症治療最先進的方式，質子束流通過超導迴旋加速器加速，以接近2/3光束的速度殺死腫瘤細胞，對腫瘤細胞進行定點爆破的同時對正常組織的損傷非常低，顯著減輕副作用。本影片中介紹了質子束產生的過程以及質子治療流程，包含治療前定位，定位影像及進行質子治療。"
          },
          {
            body:"瓦里安ProBeam<sup>®</sup>360°系統提供360度空間角度解決方案及3D影像重建技術，同時搭配最新強度調控質子治療技術，可依據腫瘤形狀進行塑造，為精準醫療更上一層樓。"
          }
        ]
      }

    }
  },
  components: {
    Back,Container,Bigmenu
  },
  methods:{
    OpenStatus(v){
     this.Bignav = v.status
    }
  }
}
</script>
<style lang="scss" scoped>
  .Subpage{
    height: 100%;
    width: 100%;
  }
  .frame {

    position: absolute;
    background-image: url("../../assets/frame.png");
    background-position: center;
    height: 1080px;
    width: 1920px;
  }
</style>
